<div class="page">
  <div class="header-page">
    <div class="title">
      Mes traductions
    </div>
    <div class="search">
      Barre de recherche
    </div>
  </div>
</div>
